import { render, staticRenderFns } from "./stateCell.vue?vue&type=template&id=18f15c12&scoped=true"
import script from "./stateCell.vue?vue&type=script&lang=js"
export * from "./stateCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f15c12",
  null
  
)

export default component.exports